import {
  StatusBadge,
  type StatusBadgeProps,
} from "@circle-react-shared/uikit/StatusBadge";
import { t } from "@/i18n-js/instance";
import { UpsellActions } from "../UpsellActions";
import { TitleHeader } from "./Title";

const offeredPaywallBadge: Record<string, StatusBadgeProps> = {
  unknown: {
    children: t("unknown"),
    variant: "default",
  },
  enabled: {
    children: t("enabled"),
    variant: "success",
  },
  disabled: {
    children: t("disabled"),
    variant: "danger",
  },
};

interface HeaderProps {
  offeredPaywallStatus: string;
  paywallName: string;
}

export const Header = ({ offeredPaywallStatus, paywallName }: HeaderProps) => (
  <div className="flex flex-row justify-between items-center">
    <div className="flex flex-row gap-x-4 items-center">
      <TitleHeader paywallName={paywallName} />
      <StatusBadge {...offeredPaywallBadge[offeredPaywallStatus]} />
    </div>
    <UpsellActions offeredPaywallStatus={offeredPaywallStatus} />
  </div>
);
